import { render, staticRenderFns } from "./ProhibitedPay.vue?vue&type=template&id=09b5aaa6&scoped=true"
import script from "./ProhibitedPay.vue?vue&type=script&lang=js"
export * from "./ProhibitedPay.vue?vue&type=script&lang=js"
import style0 from "./ProhibitedPay.vue?vue&type=style&index=0&id=09b5aaa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5aaa6",
  null
  
)

export default component.exports